import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, OnChanges, SimpleChanges, Inject, OnDestroy, TemplateRef, ViewChild, ViewChildren, QueryList, ElementRef, ChangeDetectionStrategy, NgZone } from '@angular/core';
import { DOCUMENT, DatePipe } from '@angular/common';
import colorsJsonGreen from './../../../../assets/teiasoft-themes/green.json';
import colorsJsonBlue from './../../../../assets/teiasoft-themes/blue.json';
import colorsJsonSilver from './../../../../assets/teiasoft-themes/silver.json';
import { TranslateService } from '@ngx-translate/core';
import { GridColumn, GridConfiguration } from '../teiasoft-grid-odata/teiasoft-grid-odata.component';
import { Globals } from '../../globals/globals';
import { TeiasoftGridService } from '../../services/teiasoft-bucket/teiasoft-grid.service';
import { RoundDigit } from '../../models/data/roundDigit.model';
import { UtilsService } from '../../services/utils/utils.service';
import { BackendService } from '../../services/backend/backend.service';
import { Router } from '@angular/router';
import { debounceTime, fromEvent, Subscription } from 'rxjs';
import { OpenItdcrEvent } from '../../models/app/openItdcr.model';
import { TeiasoftToasterService } from '../../services/teiasoft-bucket/teiasoft-toaster.service';
import { getDateOnlyDisplayDate, getDateOnlyKey } from '../../utils/date-only.utils';
import { EnquiryHeader } from '../../models/data/enquiry.model';
//import { MockDataService } from '../../../shared/services/mock-data.service';
//import { TranslateService } from '../../../translate.service';
declare var $: any;

export class GridDataset {
  [key: string]: any
}

export class ColumnConfiguration {
  colname?: string;
  width?: number;
  sizable?: boolean;
}

export class CustomIcoCol {
  label?: string;
  icon?: string;
  action?: string;
}

export class CalculatedCols {
  id?: number;
  icon?: string;
  tooltip?: string;
  method?: string;
  position?: string;
  header?: string;
}

export class ClickedCell {
  colName?: string;
  row?: any;
}

export class GridFilterFilter {
  dataField?: string;
  dataType?: string;
  dataOp?: string;
  dataObj?: string;
  filterValue?: any | null;
}

export class GridFilter {
  grid?: string;
  filters?: GridFilterFilter[];
}

@Component({
  selector: 'teiasoft-grid',
  templateUrl: './teiasoft-grid.component.html',
  styleUrls: ['./teiasoft-grid.component.scss']
})


export class TeiasoftGridComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {


  //@Input() columns: string[] = new Array();
  @Input() columnsToHide: string[] = new Array();
  @Input() columnsToShow: string[] = new Array();
  @Input() dataSet: any[] = new Array();
  @Input() showFooter: boolean = true;
  @Input() selectable: boolean = false;
  @Input() multiSelection: boolean = false;
  @Input() paginable: boolean = false;
  @Input() rowsPerPage: number = 5;
  @Input() theme: string = "silver"; // DEFAULT THEME
  @Input() filterable: boolean = false;
  @Input() sortable: boolean = true;
  @Input() showEditIcon: boolean = false;
  @Input() showDeleteIcon: boolean = false;
  @Input() translateRoot: string = 'grid';
  @Input() autoWidth: boolean = false;
  @Input() customIcoCols: CustomIcoCol[] = new Array();
  @Input() columnsWidthPerc: number[] = new Array();
  @Input() clearSelection: boolean = false; //M.M 3.01.24
  @Input() autoCompleteId: string = "";
  @Input() maxHeightVh: number = 50;
  @Input() minWidthVw: number = 0; // 15;
  @Input() selectedRow: any;
  @Input() selectedRows: any[] = new Array();
  @Input() dateFormat: string = "";
  @Input() dateTimeFormat: string = "";
  @Input() disableAllSelection: boolean = true;
  @Input() columnsToFilter: string[] = new Array();
  @Input() calculatedCols: CalculatedCols[] = new Array();
  @Input() containerWidth: number = 0;
  @Input() gridName: string = "";
  @Input() fullFilter: boolean = false;
  @Input() clearFilters: boolean = false;
  @Input() openFilter: boolean = false;
  @Input() roundDigitsItems: RoundDigit[] = new Array();
  @Input() enquiryNo: string = "";
  @Input() salesOfficeId?: number | null;
  @Input() scrollPosition: string = 'right';
  @Input() showLoader: boolean = true;
  @Input() origin: string = "";
  @Input() hasSummaryRow: boolean = false;
  @Input() columnsToHighlightBig: string[] = new Array();
  @Input() columnsToHighlight: string[] = new Array();
  @Input() editableFields: string[] = new Array();
  @Input() gridConfiguration: GridConfiguration = new GridConfiguration();
  @Input() gridDescription: string = "";
  @Input() title: string = "";
  @Input() gridDescriptionExtraTemplate?: TemplateRef<any>;
  @Input() gridDescriptionExtraContext: any = null;
  @Input() columnsToDisableInSettings: string[] = new Array();
  @Input() enquiryHeader?: EnquiryHeader;

  @Input() discardEditChanges: boolean = false;
  @Input() customHeaderRenderers: { [key: string]: () => { template: TemplateRef<any>, context: any } } = {};
  @Input() customRenderers: { [key: string]: (row: any) => { template: TemplateRef<any>, context: any } } = {};
  @Input() virtualScroll: boolean = false; // opt-in row virtualization; active only when rows exceed virtualScrollMinRows
  @Input() virtualScrollMinRows: number = 50;


  @Output() rowClick: EventEmitter<any> = new EventEmitter(); // EVENT EMITTED ON ROW CLICK WITH NO SELECTION SETTED
  @Output() rowsSelected: EventEmitter<any[]> = new EventEmitter(); // EVENT ON CHECKBOX SELECTION
  @Output() rowEditClick: EventEmitter<any> = new EventEmitter(); // EVENT ON EDIT ICON
  @Output() rowDeleteClick: EventEmitter<any> = new EventEmitter(); // EVENT ON DELETE ICON
  @Output() customIconClick: EventEmitter<any> = new EventEmitter(); // EVENT ON CUSTOM ICON CLICK
  @Output() customIconContextMenuClick: EventEmitter<any> = new EventEmitter(); // EVENT ON CUSTOM ICON CLICK
  @Output() setContainerWidth: EventEmitter<number> = new EventEmitter(); // EMIT THE WIDTH OF THE GRID
  @Output() onCellClick: EventEmitter<ClickedCell> = new EventEmitter();
  @Output() closeModal: EventEmitter<any> = new EventEmitter(); // GBR 05/03/2024 - MQBF-22
  @Output() imFiltering: EventEmitter<boolean> = new EventEmitter(); // For filter
  @Output() onHotChange: EventEmitter<boolean> = new EventEmitter();
  @Output() reloadMyDataset: EventEmitter<boolean> = new EventEmitter(); // Reaload my Data - Useed fro RecomputeCost
  @Output() onOpenITDCR: EventEmitter<OpenItdcrEvent> = new EventEmitter();


  /** INTERNAL VARS */
  columns: string[] = new Array();
  selectedIndex: number = -1;
  /* allSelected: boolean = false; */
  private _pageDataSet: any[] = new Array();
  get pageDataSet(): any[] { return this._pageDataSet; }
  set pageDataSet(value: any[]) {
    this._pageDataSet = value || new Array();
    this.refreshVirtualWindow();
  }
  oldPageDataSet: any[] = new Array();
  pageIndex: number = 1;
  totPages: number = 0;
  selectedIndexes: number[] = new Array();
  sortedCol: string = "";
  sortDirection: string = "";
  gridColumns: string[] = new Array();
  searchedValue: string = '';
  isLoaded: boolean = false;
  columnsConfiguration: ColumnConfiguration[] = new Array();
  gridVw: number = 0;
  filterTimerId: any; // GBR 05/03/2024 - MQBF-22
  gridFilters: GridFilter = new GridFilter();
  showFeasibilityOptionsModal: boolean = false;
  showFeasibilityOptionsItdcrModal: boolean = false;
  isModalReadOnly: boolean = false;
  feasibilityStatus: string = "";
  feasibilitySource: string = "";
  feasibilitySourceDescription: string = "";
  showSettingsDialog = false;

  itemNo: string = "";
  showModalPriceOptions: boolean = false;
  modalPriceOpenAs: string = "ctTool-Ictdr";
  costsSourceCostingToolRecordId: number | null = null;
  costsSourceCostingToolVersionId: number | null = null;
  costsSourceDescription: string = "";
  rawMaterialGrade: string | null = null;
  row: any;
  showCostingToolModal: boolean = false;
  costingToolItem: any | null = null;
  costingToolOrigin: string = '';
  costingToolUseNearestMatch: boolean = false;
  costingToolRecordId: number | null = null;
  costingToolVersionId: number | null = null;
  costingToolUnitSystem: string | null = null;
  costingToolCurrency: string | null = null;

  showDeliveryOptionsModal: boolean = false;

  resizingFlag = { isResizing: false };
  resizeSelector = {
    gridSelector: 'teiasoft-grid',
    tableSelector: '.teiasoft-grid',
    headerSelector: '.tg-header .tg-row',
    rowSelector: '.tg-row',
  }
  recalculateColumnsWidth: boolean = false;

  colIsSticky: boolean[] = [];
  colLeftPx: any[] = [];

  /** ROW VIRTUALIZATION STATE */
  displayRows: any[] = new Array();
  virtualActive: boolean = false;
  virtualStartIndex: number = 0;
  virtualPadTopPx: number = 0;
  virtualPadBottomPx: number = 0;
  private virtualWindowEnd: number = 0;
  private virtualRowHeightPx: number = 0;
  private virtualRafId: number | null = null;
  private readonly virtualOverscan: number = 8;
  private virtualScrollTargets: (HTMLElement | Window)[] = [];
  private virtualClipAncestors: HTMLElement[] = [];
  private virtualBodyResizeObserver?: ResizeObserver;
  private tgBodyEl: HTMLElement | null = null;

  @ViewChild('tgBody') set tgBodyRef(ref: ElementRef<HTMLElement> | undefined) {
    const el = ref ? ref.nativeElement : null;
    if (el === this.tgBodyEl) return;
    this.detachVirtualScrollListeners();
    this.tgBodyEl = el;
    if (el) {
      this.attachVirtualScrollListeners(el);
      this.scheduleVirtualWindowUpdate();
    }
  }

  @ViewChildren('stickyContainer') stickyContainers!: QueryList<ElementRef>;
  stickyContainerWidth: number = 0;
  private resizeSubscription!: Subscription;
  private stickyResizeObserver?: ResizeObserver;
  private readonly dateOnlyColumnsSet: Set<string> = new Set([
    'duedate',
    'offervaliditydate',
    'customerrequestdate',
    'customerdeliverydate',
    'bookedorderdate',
    'optiondate',
    'deliverydate'
  ]);

  constructor(@Inject(DOCUMENT) private document: Document, private translateService: TranslateService, private datePipe: DatePipe,
    private teiasoftGridService: TeiasoftGridService, private globals: Globals, private utils: UtilsService, private backendService: BackendService, private router: Router, private teiasoftToaster: TeiasoftToasterService,
    private zone: NgZone) {

    this.isLoaded = false;
    this.setSelectable();
  }

  ngOnInit(): void {
    this.initGridConfiguration();

    this.recoverSelection();
    window.addEventListener('resize', this.onWindowResize);
  }

  ngAfterViewInit(): void {
    /* setTimeout(() => this.isLoaded = true, 250); */
    if (this.selectedIndex && this.selectedIndex > -1) {
      /*  setTimeout(() => {
         // Scroll to position
         let _h: number = $('.tg-row').height()*(this.selectedIndex!+1);
         $('.tg-body-cnt').animate({ scrollTop: _h }, 200);
       },2000); */
      let _h: number = $('.tg-row').height() * this.selectedIndex! + 1;
      $('.tg-body-cnt').animate({ scrollTop: _h }, 250);
    }

    // GBR 05/03/2024 - MQBF-22
    if (this.filterable) setTimeout(() => $('.tg-input-filter').focus(), 250);

    this.initStickyContainerObserver();
    this.refreshStickyMetrics();

    // Listen to window resize and recalculate width
    this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(debounceTime(350)) // Adjust debounce time to improve performance
      .subscribe(() => this.refreshStickyMetrics());
  }

  private recomputeStickyAndLeft() {
    this.colIsSticky = this.gridColumns.map((_, c) => this.isSticky(c));
    this.colLeftPx = this.gridColumns.map((_, c) => this.getStickyLeftPosition(c));
  }

  recoverSelection(): void {
    if (this.selectedRows) {
      this.setSelectedOnStorage();
      this.selectedIndexes = this.selectedRows.map(sr => this.dataSet.indexOf(sr));
    }
  }

  calculateStickyContainerWidth(maxAttempts: number = 5): Promise<void> {
    return new Promise<void>((resolve) => {
      this.measureStickyContainerWidth(resolve, maxAttempts);
    });
  }

  private measureStickyContainerWidth(resolve: () => void, attemptsLeft: number, delay: number = 50): void {
    setTimeout(() => {
      const stickyElement = this.stickyContainers?.first?.nativeElement as HTMLElement | undefined;

      if (stickyElement) {
        const measuredWidth = stickyElement.offsetWidth;

        if (measuredWidth > 0 || attemptsLeft <= 0) {
          this.stickyContainerWidth = measuredWidth;
          resolve();
          return;
        }
      } else if (attemptsLeft <= 0) {
        resolve();
        return;
      }

      this.measureStickyContainerWidth(resolve, attemptsLeft - 1, delay);
    }, delay);
  }

  private hasFrozenColumnsConfigured(): boolean {
    return (this.gridConfiguration?.activeFrozenColumns ?? 0) > 0;
  }

  private refreshStickyMetrics(force: boolean = false): void {
    this.calculateStickyContainerWidth().then(() => {
      if (force || this.hasFrozenColumnsConfigured()) {
        this.recomputeStickyAndLeft();
      }
    });
  }

  private initStickyContainerObserver(): void {
    const stickyElement = this.stickyContainers?.first?.nativeElement as HTMLElement | undefined;
    if (!stickyElement || typeof ResizeObserver === 'undefined') {
      return;
    }

    this.stickyResizeObserver = new ResizeObserver(() => {
      const measuredWidth = stickyElement.offsetWidth;
      if (measuredWidth > 0 && measuredWidth !== this.stickyContainerWidth) {
        this.stickyContainerWidth = measuredWidth;
        if (this.hasFrozenColumnsConfigured()) {
          this.recomputeStickyAndLeft();
        }
      }
    });

    this.stickyResizeObserver.observe(stickyElement);
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes && changes["selectable"]) {
      this.selectable = changes["selectable"].currentValue;
      this.setSelectable();
      this.refreshStickyMetrics();
    }

    if (changes && changes["disableAllSelection"]) {
      this.disableAllSelection = changes["disableAllSelection"].currentValue;
      this.refreshStickyMetrics();
    }

    if (changes && changes["openFilter"]) {
      this.openFilter = changes["openFilter"].currentValue;
      // Ensure filter row columns align after toggling filter visibility
      if (this.fullFilter) {
        setTimeout(() => this.refreshColumnsWidth(), 0);
      }
    }

    if (changes && changes["showLoader"]) {
      this.showLoader = changes["showLoader"].currentValue;
    }

    if (changes && changes["discardEditChanges"]) {
      this.discardEditChanges = changes["discardEditChanges"].currentValue;
      if (this.discardEditChanges) {
        this.pageDataSet = new Array();
        this.pageDataSet = JSON.parse(JSON.stringify(this.oldPageDataSet));
        this.onHotChange.emit(false);
      }
    }

    if (changes && changes["origin"]) {
      this.origin = changes["origin"].currentValue;
    }

    if (changes && changes["hasSummaryRow"]) {
      this.hasSummaryRow = changes["hasSummaryRow"].currentValue;
      this.refreshVirtualWindow();
    }

    if (changes && (changes["virtualScroll"] || changes["virtualScrollMinRows"])) {
      this.refreshVirtualWindow();
    }

    if (changes && changes["columnsToHighlightBig"]) {
      this.columnsToHighlightBig = new Array();
      this.columnsToHighlightBig = changes["columnsToHighlightBig"].currentValue;
    }

    if (changes && changes["columnsToHighlight"]) {
      this.columnsToHighlight = new Array();
      this.columnsToHighlight = changes["columnsToHighlight"].currentValue;
    }

    if (changes && changes["editableFields"]) {
      this.editableFields = new Array();
      this.editableFields = changes["editableFields"].currentValue;
    }

    if (changes && changes["scrollPosition"]) {
      this.scrollPosition = changes["scrollPosition"].currentValue;
    }

    if (changes && changes["clearFilters"]) {
      this.clearFilters = changes["clearFilters"].currentValue;
      if (this.clearFilters == true) this.clearAllFilters();
    }

    if (changes && changes["multiSelection"]) {
      this.multiSelection = changes["multiSelection"].currentValue;
      this.setSelectable();
    }

    if (changes && changes["roundDigitsItems"]) {
      this.roundDigitsItems = new Array();
      this.roundDigitsItems = changes["roundDigitsItems"].currentValue;
      this.setRoundDigits();
    }


    if (changes && changes["gridName"]) {
      this.gridName = changes["gridName"].currentValue;
      // Get Filters
      this.getGridFilters();
    }

    // GBR 05/03/2024 - MQBF-22
    if (changes && changes["filterable"]) {
      this.filterable = changes["filterable"].currentValue;
    }
    // END

    if (changes && changes["columnsToHide"]) {
      this.columnsToHide = new Array();
      this.columnsToHide = changes["columnsToHide"].currentValue;
      this.getColumns();
    }

    if (changes && changes["columnsToShow"]) {
      this.columnsToShow = new Array();
      this.columnsToShow = changes["columnsToShow"].currentValue;
      this.getColumns();
    }

    if (changes && changes["calculatedCols"]) {
      this.calculatedCols = new Array();
      this.calculatedCols = changes["calculatedCols"].currentValue;
    }

    if (changes && changes["customIcoCols"]) {
      this.customIcoCols = new Array();
      this.customIcoCols = changes["customIcoCols"].currentValue;
      this.refreshStickyMetrics();
    }

    if (changes && changes["showEditIcon"]) {
      this.showEditIcon = changes["showEditIcon"].currentValue;
      this.refreshStickyMetrics();
    }

    if (changes && changes["showDeleteIcon"]) {
      this.showDeleteIcon = changes["showDeleteIcon"].currentValue;
      this.refreshStickyMetrics();
    }

    if (changes && changes["salesOfficeId"]) {
      this.salesOfficeId = changes["salesOfficeId"].currentValue;
    }

    if (changes && changes["dataSet"]) {
      this.dataSet = new Array();
      this.dataSet = changes["dataSet"].currentValue;
      this.getColumns();
      this.getSelectedIndex();
      this.setRoundDigits();
      this.refreshColumnsWidth();
      this.refreshStickyMetrics();
    }

    if (changes && changes["clearSelection"]) {
      this.clearSelection = changes["clearSelection"].currentValue;
      if (this.clearSelection) {
        sessionStorage.removeItem("TG-SELECTED-" + this.autoCompleteId);
        this.selectedRows = new Array();
      }
    }

    if (changes && changes["autoCompleteId"]) {
      this.autoCompleteId = changes["autoCompleteId"].currentValue;
    }

    if (changes && changes["selectedRow"]) {
      this.selectedRow = changes["selectedRow"].currentValue;
      this.getSelectedIndex();
    }

    if (changes && changes["selectedRows"]) {
      this.selectedRows = changes["selectedRows"].currentValue;
      this.recoverSelection();
    }

    if (changes && changes["dateFormat"]) {
      this.dateFormat = changes["dateFormat"].currentValue;
    }

    if (changes && changes["enquiryNo"]) {
      this.enquiryNo = changes["enquiryNo"].currentValue;
    }

    if (changes && changes["enquiryHeader"]) {
      this.enquiryHeader = changes["enquiryHeader"].currentValue;
    }

    if (changes && changes["dateTimeFormat"]) {
      this.dateTimeFormat = changes["dateTimeFormat"].currentValue;
    }

    if (changes && changes["columnsToFilter"]) {
      this.columnsToFilter = new Array();
      this.columnsToFilter = changes["columnsToFilter"].currentValue;
    }

    if (changes && changes["containerWidth"]) {
      if (changes["containerWidth"].currentValue != 0 && changes["containerWidth"].currentValue != changes["containerWidth"].previousValue) {
        //$('.tg-grid').width(changes["containerWidth"].currentValue - (window.innerWidth*0.05));
        //this.gridVw = changes["containerWidth"].currentValue - (window.innerWidth*0.05);
        this.containerWidth = changes["containerWidth"].currentValue;
        this.setDimensions();
        //("New width " + changes["containerWidth"].currentValue);
      }
    }

  }

  ngOnDestroy(): void {
    $('.tg-nodata-grid').hide();
    this.isLoaded = false;
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
    if (this.stickyResizeObserver) {
      this.stickyResizeObserver.disconnect();
    }
    window.removeEventListener('resize', this.onWindowResize);
    this.detachVirtualScrollListeners();
    this.removeSelectedRowsFromStorage();
  }

  onWindowResize = (): void => {
    this.refreshColumnsWidth();
    this.refreshStickyMetrics();
    this.virtualRowHeightPx = 0; // row height is vh-based: force re-measure after resize
    this.scheduleVirtualWindowUpdate();
  };

  trackByCol = (_: number, col: string) => col;
  trackByCustomIco = (_: number, c: any) => c?.key ?? c?.action ?? c?.icon ?? _;
  trackByFilter = (_: number, f: any) => f?.dataField ?? _;
  // Tracks windowed rows by their absolute index in pageDataSet; with virtualization off it equals trackByIndex
  trackByAbsoluteIndex = (localIndex: number): number => localIndex + this.virtualStartIndex;


  initGridConfiguration() {
    const userConfiguration = this.utils.getUserConfiguration();
    const savedConfig = userConfiguration.gridsConfigurations?.find(cfg => cfg.name === this.title);

    if (savedConfig) {
      // Start from saved config
      this.gridConfiguration = savedConfig;

      // Create a map of existing column names
      const existingColumnNames = new Set(this.gridConfiguration.gridColumns!.map(c => c.name));

      // Add new columns that are missing from saved config
      const nextId = this.gridConfiguration.gridColumns!.length;
      this.columnsToShow.forEach((col, idx) => {
        if (!existingColumnNames.has(col)) {
          let gc = new GridColumn();
          gc.id = nextId + idx;
          gc.name = col;
          gc.visible = true;
          gc.width = 175;
          this.gridConfiguration.gridColumns!.push(gc);
        }
      });

      // remove columns no longer in columnsToShow
      this.gridConfiguration.gridColumns = this.gridConfiguration.gridColumns!.filter(c =>
        this.columnsToShow.includes(c.name!)
      );

    } else {
      // Create new config from scratch
      this.gridConfiguration = new GridConfiguration();
      this.gridConfiguration.name = this.title;
      this.gridConfiguration.gridColumns = this.columnsToShow.map((col, idx) => {
        let gc = new GridColumn();
        gc.id = idx;
        gc.name = col;
        gc.visible = true;
        gc.width = 175;
        return gc;
      });
    }

    // Finally apply config
    if (this.gridConfiguration.gridColumns?.length > 0) {
      this.applyGridConfiguration(this.gridConfiguration);
    }
  }


  applyGridConfiguration(gridConfiguration: GridConfiguration) {
    this.gridColumns = gridConfiguration.gridColumns!.filter(gc => gc.visible).map(gc => gc.name!);
    this.setDimensions();
    this.refreshStickyMetrics(true);
  }

  getGridFilters() {
    this.teiasoftGridService.getFilters().subscribe(res => {
      this.gridFilters = new GridFilter();
      this.gridFilters = res.filter(x => x.grid! == this.gridName)[0];
      // Filters are loaded asynchronously; realign column widths once filter cells exist
      this.refreshColumnsWidth();
    });
  }

  onColumnWidthUpdate(gridConfiguration: GridConfiguration) {
    this.gridConfiguration = new GridConfiguration()
    this.gridConfiguration = gridConfiguration;
    this.onUpdateConfiguration(this.gridConfiguration);
    this.recomputeStickyAndLeft();
  }

  /**
  * GETCOLUMNS - This method provides all column name based on the dataset
  */
  getColumns() {
    if (!this.dataSet || this.dataSet.length == 0) {
      this.setPagination();
    }

    this.gridColumns = new Array();

    if (this.columnsToShow && this.columnsToShow.length > 0) {
      this.gridColumns = this.columnsToShow.filter(x => x != 'summary');
    }
    else {
      for (let x = 0; x < this.dataSet.length; x++) {
        for (const key in this.dataSet[x]) {
          if (key != 'summary' && this.columnsToHide.findIndex(x => x.toLowerCase() == key.toLowerCase()) == -1) {
            if (this.gridColumns.indexOf(key) == -1)
              this.gridColumns.push(key);
          }
        }
      }
    }

    this.setPagination();
  }

  /**
   * GET SELECTED ROW/INDEX
   */
  getSelectedIndex() {
    if (!this.selectedRow) return;
    if (!this.pageDataSet || this.pageDataSet.length == 0) return;
    for (var x = 0; x < this.pageDataSet.length; x++) {
      /*       if (this.pageDataSet[x] === this.selectedRow){
              this.selectedIndex = x;
            } */
      /* if (this.compareObjects(this.pageDataSet[x], this.selectedRow)){
        this.selectedIndex = x;
      } */
      if (JSON.stringify(this.pageDataSet[x]) === JSON.stringify(this.selectedRow)) {
        this.selectedIndex = x;
        break;
      }

      if (Object.keys(this.selectedRow).indexOf("npsScheduleId") != -1) {
        if (this.pageDataSet[x]["npsScheduleId"] === this.selectedRow["npsScheduleId"]) {
          this.selectedIndex = x;
          break;
        }
      }
    }
  }

  trackByIndex(index: number, item: any): any {
    return index;
  }


  compareObjects(obj1: any, obj2: any): boolean {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!keys2.includes(key)) {
        return false;
      }

      const val1 = obj1[key];
      const val2 = obj2[key];

      // Check if the values are objects and recursively compare them
      if (typeof val1 === 'object' && typeof val2 === 'object') {
        if (!this.compareObjects(val1, val2)) {
          return false;
        }
      } else {
        if (val1 !== val2) {
          return false;
        }
      }
    }

    return true;
  }

  setRoundDigits() {
    // ROUND DIGITS
    if (!this.roundDigitsItems || this.roundDigitsItems.length == 0) return;
    if (!this.dataSet || this.dataSet.length == 0) return;

    for (var k = 0; k < this.dataSet.length; k++) {
      let _unitSystem: string = this.dataSet[k]["unitSystem"];
      for (const prop in this.dataSet[k]) {
        let _i: number = this.roundDigitsItems.findIndex(x => x.fieldName?.toLowerCase() == prop.toLowerCase());
        if (_i != -1) {
          if (_unitSystem == 'Metric' && this.dataSet[k][prop] != null && this.dataSet[k][prop] != '')
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop]).toFixed(this.roundDigitsItems[_i].metricDigits!);

          if (_unitSystem == 'Imperial' && this.dataSet[k][prop] != null && this.dataSet[k][prop] != '')
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop]).toFixed(this.roundDigitsItems[_i].imperialDigits!);
        } /* else {
          if (_unitSystem == 'Metric' && this.dataSet[k][prop] != null)
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop].toFixed(2));
          
          if (_unitSystem == 'Imperial' && this.dataSet[k][prop] != null)
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop].toFixed(2));
        } */
      }
    }

  }

  /** PAGINATION */
  public setPagination(): void {
    if (!this.pageDataSet) this.pageDataSet = new Array();
    if (this.paginable) {
      this.pageDataSet = this.dataSet.slice((this.pageIndex - 1) * this.rowsPerPage, this.pageIndex * this.rowsPerPage);
      this.totPages = Math.ceil(this.dataSet.length / this.rowsPerPage);
      //if (this.totPages == 0) this.totPages = 1;
    } else {
      this.pageDataSet = this.dataSet;
    }

    this.oldPageDataSet = new Array();
    this.oldPageDataSet = JSON.parse(JSON.stringify(this.pageDataSet));
    this.setDimensions();
    this.refreshColumnsWidth();
  }

  refreshColumnsWidth() {
    this.recalculateColumnsWidth = true;
    setTimeout(() => {
      this.recalculateColumnsWidth = false;
    }, 150);
  }

  /** ROW VIRTUALIZATION (opt-in via virtualScroll input) */
  private refreshVirtualWindow(): void {
    const rows = this._pageDataSet || new Array();
    const eligible = this.virtualScroll && !this.paginable && !this.hasSummaryRow && rows.length > this.virtualScrollMinRows;

    if (!eligible) {
      this.virtualActive = false;
      this.virtualStartIndex = 0;
      this.virtualWindowEnd = rows.length;
      this.virtualPadTopPx = 0;
      this.virtualPadBottomPx = 0;
      this.displayRows = rows;
      return;
    }

    this.virtualActive = true;
    this.applyVirtualWindow(this.computeVirtualWindow());
    this.scheduleVirtualWindowUpdate(); // realign on the painted geometry on the next frame
  }

  private applyVirtualWindow(w: { start: number, end: number, rowH: number }): void {
    const total = this._pageDataSet.length;
    this.virtualStartIndex = w.start;
    this.virtualWindowEnd = w.end;
    this.displayRows = this._pageDataSet.slice(w.start, w.end);
    this.virtualPadTopPx = Math.round(w.start * w.rowH);
    this.virtualPadBottomPx = Math.max(0, Math.round((total - w.end) * w.rowH));
  }

  private computeVirtualWindow(): { start: number, end: number, rowH: number } {
    const total = this._pageDataSet.length;
    const rowH = this.virtualRowHeightPx > 0 ? this.virtualRowHeightPx : Math.max(1, window.innerHeight * 0.036); // .tg-cell is 3.6vh tall
    const fallbackCount = Math.ceil((window.innerHeight * (this.maxHeightVh / 100)) / rowH) + this.virtualOverscan * 2;
    const body = this.tgBodyEl;

    if (!body) return { start: 0, end: Math.min(total, fallbackCount), rowH };

    const bodyRect = body.getBoundingClientRect();
    // Hidden container (display:none): keep an initial window, the ResizeObserver realigns on reveal
    if (bodyRect.width === 0 && bodyRect.height === 0) return { start: 0, end: Math.min(total, fallbackCount), rowH };

    // Visible span of the rows container = its rect intersected with every clipping ancestor and the window viewport
    let clipTop = 0;
    let clipBottom = window.innerHeight;
    for (const ancestor of this.virtualClipAncestors) {
      const r = ancestor.getBoundingClientRect();
      if (r.top > clipTop) clipTop = r.top;
      if (r.bottom < clipBottom) clipBottom = r.bottom;
    }

    const visibleTop = Math.max(0, clipTop - bodyRect.top);
    const visibleHeight = Math.max(0, clipBottom - Math.max(clipTop, bodyRect.top));
    const start = Math.min(Math.max(0, Math.floor(visibleTop / rowH) - this.virtualOverscan), Math.max(0, total - 1));
    const count = Math.max(1, Math.ceil(visibleHeight / rowH)) + this.virtualOverscan * 2;
    return { start: start, end: Math.min(total, start + count), rowH };
  }

  private measureVirtualRowHeight(): void {
    const firstRow = this.tgBodyEl ? this.tgBodyEl.querySelector('.tg-body-row') : null;
    if (firstRow) {
      const h = (firstRow as HTMLElement).getBoundingClientRect().height;
      if (h > 0) this.virtualRowHeightPx = h;
    }
  }

  // Arrow function: used directly as scroll/resize callback; runs outside the Angular zone and
  // re-enters it only when the visible row window actually changes.
  private scheduleVirtualWindowUpdate = (): void => {
    if (!this.virtualActive || this.virtualRafId != null) return;
    this.virtualRafId = requestAnimationFrame(() => {
      this.virtualRafId = null;
      if (!this.virtualActive) return;
      this.measureVirtualRowHeight();
      const w = this.computeVirtualWindow();
      if (w.start !== this.virtualStartIndex || w.end !== this.virtualWindowEnd) {
        this.zone.run(() => this.applyVirtualWindow(w));
      }
    });
  };

  private attachVirtualScrollListeners(el: HTMLElement): void {
    this.zone.runOutsideAngular(() => {
      const targets: (HTMLElement | Window)[] = [];
      const clips: HTMLElement[] = [];
      let node: HTMLElement | null = el.parentElement;
      while (node) {
        const overflowY = getComputedStyle(node).overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll') {
          targets.push(node);
          clips.push(node);
        } else if (overflowY === 'hidden' || overflowY === 'clip') {
          clips.push(node);
        }
        node = node.parentElement;
      }
      targets.push(window);
      targets.forEach(t => t.addEventListener('scroll', this.scheduleVirtualWindowUpdate, { passive: true }));
      this.virtualScrollTargets = targets;
      this.virtualClipAncestors = clips;

      if (typeof ResizeObserver !== 'undefined') {
        this.virtualBodyResizeObserver = new ResizeObserver(() => this.scheduleVirtualWindowUpdate());
        this.virtualBodyResizeObserver.observe(el);
      }
    });
  }

  private detachVirtualScrollListeners(): void {
    this.virtualScrollTargets.forEach(t => t.removeEventListener('scroll', this.scheduleVirtualWindowUpdate));
    this.virtualScrollTargets = [];
    this.virtualClipAncestors = [];
    if (this.virtualBodyResizeObserver) {
      this.virtualBodyResizeObserver.disconnect();
      this.virtualBodyResizeObserver = undefined;
    }
    if (this.virtualRafId != null) {
      cancelAnimationFrame(this.virtualRafId);
      this.virtualRafId = null;
    }
  }


  /**
 * CHECK FOR CORRECT SELECTION
 */
  setSelectable() {
    if (!this.selectable) this.multiSelection = false;
  }


  /***
   * This method provide a calculation of the dimension of the single columns based on the largest string inside
   */
  setDimensions() {
    this.gridVw = 0;
    const maxLengths: any = {};
    this.columnsConfiguration = new Array();


    if (this.columnsToShow && this.columnsToShow.length > 0) {
      this.columnsToShow = this.columnsToShow.filter(x => x != 'summary');

      this.columnsToShow = this.gridConfiguration && this.gridConfiguration.gridColumns && this.gridConfiguration.gridColumns ? this.gridConfiguration.gridColumns!.filter(gc => gc.visible).map(gc => gc.name!) : this.columnsToShow;

      this.columnsToShow.forEach((column) => {
        // Store in Array the single key values
        let _list: any[] = this.dataSet.map(x => x[column]);
        let _length: number = 0;
        if (_list.every(x => x == null) || _list.every(x => x == undefined)) { // if every column value is null or undefined we have an empty column
          _length = 10; // Default for empty columns
        } else {
          // GBR 22/07/2024 - Tolgo  eventuali null
          _list = _list.filter(l => l != null);
          _length = _list.sort(
            function (a, b) {
              return b.length - a.length;
            })[0].toString().length;
        }

        let _item: ColumnConfiguration = new ColumnConfiguration();
        _item.colname = column;
        _item.sizable = false;
        // Check se è colonna calcolata
        let _isCalculated: boolean = false;
        for (var x = 0; x < this.calculatedCols.length; x++) {
          if (this.calculatedCols[x].method!.split("|")[1].toLowerCase() == _item.colname.toLowerCase()) {
            _isCalculated = true;
            break;
          }
        }
        if (_isCalculated) {
          _item.width = 2.4;
        } else {
          let _w: number = _length * 0.65;
          _item.width = _w < 8.5 ? 8 : (_w > 35 ? 35 : _w) // Setto la massima dimensione a 50 e la minima a 8.5
        }

        this.columnsConfiguration.push(_item);
        this.gridVw += _item.width!;
      });

    }
    else {
      // GBR 23/02/2034 - Attenzione: gli elementi del DataSet potrebbero essere diversi. Ad esmpio, un oggetto alla riga 0 potrebbe essere null
      // mentre alla riga 1 potrebbe essere valorizzato. Questo fà sì che il dato non venga valorizzato. Occorre trovare quindi quell'elemento
      //dell'array che ha il maggior numero di proprietà e usare quello per costruire le colonne
      let _num: number[] = new Array();
      for (var x = 0; x < this.dataSet.length; x++) {
        _num.push(Object.keys(this.dataSet[x]).length);
      }
      const max = Math.max(..._num);
      let _i: number = _num.indexOf(max);

      let obj: any = this.dataSet[_i];
      for (const key in obj) {
        let _i: number = -1;
        if (this.columnsToHide && this.columnsToHide.length > 0) _i = this.columnsToHide.findIndex(x => x.toLowerCase() == key.toLowerCase());
        if (obj.hasOwnProperty(key) && _i == -1) { /* && typeof obj[key] === "string" */
          // Store in Array the single key values
          let _list: any[] = this.dataSet.map(x => x[key]);
          let _length: number = 0;
          if (_list.length > 1 && _list[0] == null) {
            _length = 10; // Default for empty colums
          } else {
            _length = _list.sort(
              function (a, b) {
                return b.length - a.length;
              })[0].toString().length;
          }

          let _item: ColumnConfiguration = new ColumnConfiguration();
          _item.colname = key;
          _item.sizable = false;
          // Check se è colonna calcolata
          let _isCalculated: boolean = false;
          for (var x = 0; x < this.calculatedCols.length; x++) {
            if (this.calculatedCols[x].method!.split("|")[1].toLowerCase() == _item.colname.toLowerCase()) {
              _isCalculated = true;
              break;
            }
          }
          if (_isCalculated) {
            _item.width = 2.4;
          } else {
            let _w: number = 0.65;
            _item.width = _w < 8.5 ? 8.5 : (_w > 35 ? 35 : _w) // Setto la massima dimensione a 50 e la minima a 8.5
          }

          this.columnsConfiguration.push(_item);
          this.gridVw += _item.width!;

          // Check if the property exists in the maxLengths object
          // If not, initialize it with the length of the current value
          /* let _objLength: number = obj[key].length ? obj[key].length : 10;
          if (!maxLengths[key] || _objLength > maxLengths[key]) {
            let _item: ColumnConfiguration = new ColumnConfiguration();
            _item.colname = key;
            _item.sizable = false;
            let _w: number = _objLength*0.65;
            _item.width = _w < 5 ? 5 : _w
            this.columnsConfiguration.push(_item);
            maxLengths[key] = _objLength;
            this.gridVw += _item.width!;
          } */
        }
      }
    }
    //});
    let _colsW: number = 0;
    if (this.showEditIcon) _colsW += 3;
    if (this.showDeleteIcon) _colsW += 3;
    _colsW += this.customIcoCols.length * 3;
    //f (this.fullFilter) _colsW+=this.columnsConfiguration.length*1.6;

    //this.gridVw-= 2; 
    //let _minWidthVw: number = this.minWidthVw - 1.042 - (this.columnsConfiguration.length*1.6); // Scroll bar and padding
    // CHECK IF TOTAL IS SMALLER THAN MIN WIDTH
    if (this.minWidthVw > 0 && (this.gridVw + _colsW) < this.minWidthVw) {
      let _diff: number = (this.minWidthVw - (this.gridVw + _colsW)) / this.columnsConfiguration.length;
      this.gridVw = 0;
      for (var x = 0; x < this.columnsConfiguration.length; x++) {
        this.columnsConfiguration[x].width! += _diff;
        this.gridVw += this.columnsConfiguration[x].width!;
      }
    }

    // CHECK IF TOTAL IS BIGGER THAN MIN WIDTH
    if (this.minWidthVw > 0 && (this.gridVw + _colsW) > this.minWidthVw) {
      let _diff: number = ((this.gridVw + _colsW) - this.minWidthVw) / this.columnsConfiguration.length;
      this.gridVw = 0;
      for (var x = 0; x < this.columnsConfiguration.length; x++) {
        this.columnsConfiguration[x].width! -= _diff;
        this.gridVw += this.columnsConfiguration[x].width!;
      }
    }

    this.gridVw += _colsW;
    // Transform in pixel MQF-338
    this.gridVw = window.innerWidth * (this.gridVw / 100);

    if (this.gridVw < this.containerWidth) this.gridVw = this.containerWidth;
    this.setContainerWidth.emit(this.gridVw);
    setTimeout(() => {
      this.isLoaded = true;
      if (this.pageDataSet.length == 0)
        $('.tg-nodata-grid').show();
      else
        $('.tg-nodata-grid').hide();
    }, 0);

    // console.log(this.gridName + " grid Configuration (total w is " + this.gridVw +")", this.columnsConfiguration);
  }

  getColumnsWidth(col: string): number {
    let _i: number = this.columnsConfiguration.findIndex(x => x.colname?.toLowerCase() == col.toLowerCase());
    if (_i != -1) {
      return this.columnsConfiguration[_i].width!;
    } else {
      return 0;
    }
  }

  getConfiguredColumnWidth(col: string): number | null {
    const configuredWidth = this.gridConfiguration?.gridColumns?.find(gc => gc.name?.toLowerCase() == col.toLowerCase())?.width;
    return typeof configuredWidth === 'number' && configuredWidth > 0 ? configuredWidth : null;
  }

  getColumnResizable(col: string): boolean {
    let _i: number = this.columnsConfiguration.findIndex(x => x.colname?.toLowerCase() == col.toLowerCase());
    if (_i != -1) {
      return this.columnsConfiguration[_i].sizable!;
    } else {
      return false;
    }
  }

  /*   setResizableEvents(){
      const resizers = document.querySelectorAll('tg-cell-resizable');
      for (let i = 0;i < resizers.length; i++) {
        const currentResizer = resizers[i];
        currentResizer.addEventListener('mousedown', function(e) {
          currentResizer.addEventListener('mousemove', resize)
        })
        
        function resize(e:any) {
          if (currentResizer.classList.contains('bottom-right')) {
            element.style.width = e.pageX - element.getBoundingClientRect().left + 'px';
          }
        }
      }
    } */

  onMouseDown(col: string, evt: any, i: number) {
    let _i: number = this.columnsConfiguration.findIndex(x => x.colname?.toLowerCase() == col.toLowerCase());
    if (_i == -1 || !this.columnsConfiguration[_i].sizable) return;
    const _elem = document.getElementById(evt.currentTarget.id);
    _elem!.addEventListener('mousemove', (res) => {
      //let _w: number = _elem!.getBoundingClientRect().width;
      /* $('#tg-cell_' + i).width(_w); */
      let _w: string = ((res.pageX - _elem!.getBoundingClientRect().left) + 20) + 'px';
      let _col = document.getElementById('tg-cell_' + i);
      _col!.style.width = _w;
      _elem!.removeEventListener('mousemove', () => { });
    });
  }

  onMouseUp(evt: any) {
    return;
    /*     const _elem = document.getElementById(evt.currentTarget.id);
        _elem!.removeEventListener('mousemove', () => { });
        console.log("Removed eventlistener"); */
  }

  /**
   * FILTER ON KEY UP
   */
  /*   onKeyupFilter(e: KeyboardEvent) {
      if (this.searchedValue.length > 0) {
        //this.pageDataSet = this.dataSet.filter(o => Object.keys(o).some(k => o[k].toString().toLowerCase().includes(this.searchedValue.toLowerCase())));
        if (!this.columnsToFilter || this.columnsToFilter.length == 0){
          this.pageDataSet = this.dataSet.filter((o: any) => {
            return Object.keys(o).some((k) => {
              const value = o[k];
          
              if (value !== null && value !== undefined) {
                return value.toString().toLowerCase().includes(this.searchedValue.toLowerCase());
              }
          
              return false;
            });
          });
        } else {
          this.pageDataSet = this.dataSet.filter(x => x[this.columnsToFilter[0]].toLowerCase().includes(this.searchedValue.toLowerCase()));
        }
      } else {
        this.setPagination();
      }
    } */

  // GBR 05/03/2024 - MQBF-22
  onKeyupFilter(e: KeyboardEvent) {
    /*    if (e.keyCode == 9){
         $('.teiasoft-grid').focus();
         this.selectedIndex! = 0;
         return;
       } */

    if (this.searchedValue.length > 0) {
      if (!this.columnsToFilter || this.columnsToFilter.length == 0) {
        this.pageDataSet = this.dataSet.filter((o: any) => {
          return Object.keys(o).some((k) => {
            const value = o[k];
            if (value !== null && value !== undefined) {
              return value.toString().toLowerCase().includes(this.searchedValue.toLowerCase());
            }
            return false;
          });
        });
      } else {
        this.pageDataSet = this.dataSet.filter(x => x[this.columnsToFilter[0]].toLowerCase().includes(this.searchedValue.toLowerCase()));
      }

      if (this.filterTimerId != undefined) clearTimeout(this.filterTimerId);
      this.filterTimerId = setTimeout(() => {
        this.selectedIndex = 0;
        $('.tg-body-cnt').focus();
        clearTimeout(this.filterTimerId);
      }, 500);

    } else {
      this.setPagination();
    }
  }

  // GBR 05/03/2024 - MQBF-22 - Deprecated
  onGridKeyDown(evt: any) {
    evt.preventDefault();

    // Arrow UP
    if (evt.keyCode == 38) {
      if (this.selectedIndex == 0) return;
      this.selectedIndex!--;

      let _scroll: number = $('#cntBodyGrid').scrollTop();
      let _scrollH: number = $('#cntBodyGrid').height();
      let _rowH: number = $('.tg-row').height();
      if (_scrollH < (_rowH * (this.pageDataSet.length - this.selectedIndex!))) {
        $('#cntBodyGrid').scrollTop(_scroll - Math.round(_rowH));
      }
    }

    // Arrow DOWN
    if (evt.keyCode == 40) {
      if (this.selectedIndex == undefined) this.selectedIndex = -1;
      if (this.selectedIndex == this.pageDataSet.length - 1) return;
      this.selectedIndex!++;
      let _scroll: number = $('#cntBodyGrid').scrollTop();
      let _scrollH: number = $('#cntBodyGrid').height();
      let _rowH: number = $('.tg-row').height();
      if (_scrollH < (_rowH * this.selectedIndex!)) {
        $('#cntBodyGrid').scrollTop(_scroll + Math.round(_rowH));
      }
    }

    /* ENTER */
    if (evt.keyCode == 13) {
      if (this.selectable) return;
      this.rowClick.emit(this.pageDataSet[this.selectedIndex!]);
      this.closeModal.emit('');
    }
  }

  /**
   * EVENT ON ROW CLICK (ONLY FOR SELECTABLE == FALSE)
   */
  onRowClick(e: Event, row: any, i: number) {
    if (this.selectable) return;
    this.selectedIndex = i;
    this.rowClick.emit(row);
  }

  /**
   * GET THE TYPE OF THE VALUE PRINTED ON CELL
   * @param val 
   * @returns 
   */
  getValueType(val: any): string {
    return typeof val;
  }

  /***
   * EMIT EVENT ON MULTI SELECTION
   */
  /*   onChckAllRowsClick() {
      // SELECT ALL CHECKBOXES
      for (var x = 0; x < this.dataSet.length; x++) {
        const checkbox = document.getElementById('ckb_' + x) as HTMLInputElement | null;
        if (checkbox != null) {
          checkbox.checked = !this.allSelected;
        }
      }
      this.allSelected = !this.allSelected;
      this.selectedRows = new Array();
      if (this.allSelected && this.paginable) {
        for (var x = ((this.pageIndex - 1) * this.rowsPerPage); x < (this.pageIndex * this.rowsPerPage); x++) {
          this.selectedRows.push(this.dataSet[x]);
        }
      } else if (this.allSelected && !this.paginable) {
        for (var x = 0; x < this.dataSet.length; x++) {
          this.selectedRows.push(this.dataSet[x]);
        }
      }
  
      this.rowsSelected.emit(this.selectedRows);
    } */

  onSelectAllRows() {
    if (!this.selectedRows) this.selectedRows = new Array();
    if (!this.selectedIndexes) this.selectedIndexes = new Array();

    if (this.selectedIndexes.length == 0) {
      for (var x = 0; x < this.pageDataSet.length; x++) {
        this.selectedIndexes.push(x);
        this.selectedRows.push(this.pageDataSet[x]);
      }
    } else {
      if (this.selectedIndexes.length == this.pageDataSet.length) {
        this.selectedRows = new Array();
        this.selectedIndexes = new Array();
      } else {
        this.selectedRows = new Array();
        this.selectedIndexes = new Array();
        // for (var x = 0; x < this.pageDataSet.length; x++) {
        //   this.selectedIndexes.push(x);
        //   this.selectedRows.push(this.pageDataSet[x]);
        // }
      }
    }


    // All selected, I've to de-select all
    /*  if (this.selectedRows.length == this.pageDataSet.length) {
       this.selectedRows = new Array();
       this.selectedIndexes = new Array();
       for (var x = 0; x < this.dataSet.length; x++) {
         const checkbox = document.getElementById('ckb_' + x) as HTMLInputElement | null;
         if (checkbox != null) {
           checkbox.checked = false;
         }
       }
     } else if (this.selectedRows.length != this.pageDataSet.length) { // Some Selected or none selected, I'VE to select all 
       this.selectedRows = new Array();
       for (var x = 0; x < this.dataSet.length; x++) {
         const checkbox = document.getElementById('ckb_' + x) as HTMLInputElement | null;
         if (checkbox != null) {
           checkbox.checked = true;
         }
       }
 
       if (this.paginable) {
         for (var x = ((this.pageIndex - 1) * this.rowsPerPage); x < (this.pageIndex * this.rowsPerPage); x++) {
           this.selectedRows.push(this.dataSet[x]);
         }
       } else if (!this.paginable) {
         for (var x = 0; x < this.dataSet.length; x++) {
           this.selectedRows.push(this.dataSet[x]);
         }
       }
     } */

    if (this.autoCompleteId != '') this.setSelectedOnStorage(); // Save on session for Autocomplete
    this.rowsSelected.emit(this.selectedRows);
  }

  /***
   * EMIT EVENT ON SINGLE SELECTION
   */
  onChkSelectRowClick(row: any, i: number) {
    if (!this.selectable) return;
    //if (!this.selectedRows) this.selectedRows = new Array();

    if (!this.selectedIndexes) this.selectedIndexes = new Array();
    if (this.selectedIndexes.findIndex(x => x == i) == -1) {
      this.selectedIndexes.push(i);
    } else {
      this.selectedIndexes = this.selectedIndexes.filter(x => x != i);
    }

    this.selectedRows = new Array();
    for (var x = 0; x < this.selectedIndexes.length; x++) {
      this.selectedRows.push(this.pageDataSet[this.selectedIndexes[x]]);
    }
    // Check if the row is already in the selectedRows list
    /*  let _isSelected: boolean = false;
     let _i: number = -1;
     for (var x = 0; x < this.selectedRows.length; x++) {
       if (JSON.stringify(this.selectedRows[x]) === JSON.stringify(row)) {
         _isSelected = true;
         _i = -1;
         break;
       }
     }
 
     if (!_isSelected) {
       this.selectedRows.push(row);
     } else {
       if (this.selectedRows.length == 1)
         this.selectedRows = new Array();
       else
         this.selectedRows.splice(_i, 1);
     } */

    if (this.autoCompleteId != '') this.setSelectedOnStorage();
    this.rowsSelected.emit(this.selectedRows);
  }

  checkIfImChecked(row: any, i: number): boolean {
    this.readSelectedFromStorage();
    if (this.selectedIndexes.findIndex(x => x == i) == -1) {
      return false;
    } else {
      return true;
    }

    /*  for (var x = 0; x < this.selectedRows.length; x++) {
       if (JSON.stringify(this.selectedRows[x]) === JSON.stringify(row)) {
         return true;
       }
     }
     return false; */
  }

  /***
   * PAGINATOR EVENTS
   */
  onClickPageBack() {
    if (this.pageIndex == 1) return;
    this.pageIndex -= 1;
    this.setPagination();
  }

  onClickPageForward() {
    if (this.pageIndex == this.totPages) return;
    this.pageIndex += 1;
    this.setPagination();
  }

  /***
   * SORT EVENT
   */
  onSortClick(colName: string) {
    if (!this.sortable) return;
    if (this.resizingFlag.isResizing) return;  // Do not sort while resizing
    let _tempDataSet: any[] = new Array();
    this.sortedCol = colName;
    this.sortDirection = (this.sortDirection == '' || this.sortDirection == 'asc') ? 'desc' : 'asc';
    if (this.sortDirection == 'asc') {
      _tempDataSet = this.orderByArrayAsc(this.dataSet, colName); //.map(item => item.name)
    } else {
      _tempDataSet = this.orderByArrayDesc(this.dataSet, colName); //.map(item => item.name)
    }

    this.dataSet = new Array();
    this.dataSet = _tempDataSet;
    if (this.paginable) {
      this.setPagination();
    } else {
      this.pageDataSet = new Array();
      this.pageDataSet = _tempDataSet;
    }
  }

  getSortIcon(colName: string): string {
    if (!this.sortable) return "";
    if (this.sortedCol == '') return "";
    if (this.sortedCol == colName) {
      if (this.sortDirection == 'asc')
        return "&#8593;";
      else
        return "&#8595;";
    } else {
      return "";
    }
  }

  orderByArrayAsc(values: any[], orderType: any) {
    return values.sort((a, b) => {
      if (a[orderType] < b[orderType]) {
        return -1;
      }

      if (a[orderType] > b[orderType]) {
        return 1;
      }
      return 0
    });
  }

  orderByArrayDesc(values: any[], orderType: any) {
    return values.sort((a, b) => {
      if (a[orderType] > b[orderType]) {
        return -1;
      }

      if (a[orderType] < b[orderType]) {
        return 1;
      }
      return 0
    });
  }

  /**
   * EDIT/DELETE ICONS EVENT
   */
  onEditClick(e: Event, row: any) {
    e.stopPropagation();
    this.rowEditClick.emit(row);
  }

  onDeleteClick(e: Event, row: any) {
    e.stopPropagation();
    this.rowDeleteClick.emit(row);
  }

  /**
   * GET COLUMN NAME
   */
  getColumnLabel(columnName: string, index: number): string {
    // Mapping of measure columns to their respective UOM columns
    const uomColumnsMapping: any = {
      od: "odUom",
      id: "idUom",
      wt: "wtUom",
      lengthNominal: "lengthUom",
      lengthMin: "lengthUom",
      lengthMax: "lengthUom"
    };

    // Fallbacks for UOM columns if primary is empty
    const uomFallbacks: Record<string, string> = {
      od: "id",
      id: "od",
      wt: "od"
    };

    // Check if the column has a corresponding UOM column
    if (uomColumnsMapping[columnName]) {
      const primaryUomCol = uomColumnsMapping[columnName];
      let uomValue = this.dataSet.length > 0 ? this.dataSet[0][primaryUomCol] : "";

      // If no UOM and a fallback exists, try the fallback's UOM
      if (!uomValue && uomFallbacks[columnName]) {
        const fallbackColumn = uomFallbacks[columnName];
        const fallbackUomCol = uomColumnsMapping[fallbackColumn];
        uomValue = this.dataSet.length > 0 ? this.dataSet[0][fallbackUomCol] : "";
      }

      // Translate and append UOM to the label
      const baseLabel = this.translateService.instant(
        this.translateRoot + "." + columnName.charAt(0).toUpperCase() + columnName.slice(1)
      );
      return uomValue ? `${baseLabel} (${uomValue})` : baseLabel;
    }

    // Default logic for other columns
    for (var x = 0; x < this.calculatedCols.length; x++) {
      if (this.calculatedCols[x].method!.split("|")[1].toLowerCase() == columnName.toLowerCase()) {
        return this.calculatedCols[x].header!;
      }
    }

    let _colName: string = columnName.substring(0, 1).toUpperCase() + columnName.substring(1, columnName.length);
    if (this.gridName == 'users' && _colName == 'CreationDate') _colName = 'creationDateUser';
    return this.translateService.instant(this.translateRoot + "." + _colName);
  }


  /**
   * GET FOOTER CALC ITEMS
   */
  getFooterCalcItems(): string {
    if (this.pageIndex * this.rowsPerPage > this.dataSet.length)
      return this.dataSet.length.toString();
    else
      return (this.pageIndex * this.rowsPerPage).toString();
  }

  /**
   * UTILS
   */
  isEven(n: number): boolean {
    return n % 2 == 0;
  }

  /***
   * PUBLIC METHODS
   */
  public setInputValue(propName: string, value: any) {

  }

  getCustomColTitle(label: string): string {
    return this.translateService.instant(this.translateRoot + "." + label);
  }

  onCustomIcoClick(action: string, row: any) {
    this.customIconClick.emit(action + "|" + JSON.stringify(row));
  }

  readSelectedFromStorage() {
    if (sessionStorage.getItem("TG-SELECTED-" + this.autoCompleteId)) {
      this.selectedRows = new Array();
      this.selectedRows = JSON.parse(sessionStorage.getItem("TG-SELECTED-" + this.autoCompleteId)!);
    }
  }

  setSelectedOnStorage() {
    sessionStorage.setItem("TG-SELECTED-" + this.autoCompleteId, JSON.stringify(this.selectedRows));
  }

  private removeSelectedRowsFromStorage(): void {
    if (!this.autoCompleteId) {
      return;
    }

    sessionStorage.removeItem("TG-SELECTED-" + this.autoCompleteId);
  }

  getBooleanValue(row: any, col: string, value: any): string {
    if (value === true) return this.translateService.instant("noTranslations.yes");
    if (value === false) return this.translateService.instant("noTranslations.no");

    return '';
  }


  // Lookup map for calculated columns, rebuilt only when the calculatedCols input array changes reference
  private calculatedColsMapSource: CalculatedCols[] | null = null;
  private calculatedColsMap: Map<string, CalculatedCols> = new Map();

  private getCalculatedColByName(col: string): CalculatedCols | undefined {
    if (this.calculatedColsMapSource !== this.calculatedCols) {
      this.calculatedColsMap = new Map();
      for (const cc of (this.calculatedCols || [])) {
        const name = cc.method?.split("|")[1]?.toLowerCase();
        if (name && !this.calculatedColsMap.has(name)) this.calculatedColsMap.set(name, cc);
      }
      this.calculatedColsMapSource = this.calculatedCols;
    }
    return this.calculatedColsMap.get(col.toLowerCase());
  }

  isCalculatedColumn(col: string): boolean {
    return this.getCalculatedColByName(col) !== undefined;
  }

  getValue(row: any, col: string, value: any): any {
    // Check se è colonna calcolata
    const _calcCol = this.getCalculatedColByName(col);
    if (_calcCol) {
      let _col: CalculatedCols = new CalculatedCols();
      _col = this.teiasoftGridService.getCalculatedColNoOdata(_calcCol, row);

      if ((col == 'feasibilityStatus' && this.origin == 'edit-enquiry') || (col == 'costsStatus' && this.origin == 'edit-enquiry')) {
        let _class: string = this.customIcoClickable(col) ? 'app-ico-sm' : '';
        return "<i class='" + _col.icon! + " " + _class + "'></i>";
      } else {
        return "<i class='" + _col.icon! + "'></i>";
      }
    }

    if (typeof value !== 'number') return value;

    const _date = this.getDisplayDate(value, col);
    const _refDate = new Date('2000-01-01')
    if (!isNaN(_date.getTime()) && _date.getTime() > _refDate.getTime()) {
      // If not assigned in input
      if (this.dateFormat == '' || this.dateTimeFormat == '') {
        this.dateFormat = this.globals.dateFormat!;
        this.dateTimeFormat = this.globals.dateTimeFormat!;
      }

      if (this.gridName != undefined && this.gridName != null && this.gridName != '') {
        if (this.gridName == 'users') {
          if (col.toLocaleLowerCase() == 'creationdate' || col.toLowerCase() == 'lastupdate') {
            return this.datePipe.transform(_date, this.dateFormat);
          } else {
            return this.datePipe.transform(_date, this.dateTimeFormat);
          }
        } else if (this.gridName == 'historyDetail') {
          return this.datePipe.transform(_date, this.dateTimeFormat);
        } else {
          if (!this.isDateOnlyColumn(col)) {
            return this.datePipe.transform(_date, this.dateTimeFormat);
          } else {
            return this.datePipe.transform(_date, this.dateFormat);
          }
        }
      } else {
        if (col.toLocaleLowerCase() == 'creationdate' || col.toLocaleLowerCase() == 'lastrevisiondate') {
          return this.datePipe.transform(_date, this.dateTimeFormat);
        }

        return this.datePipe.transform(_date, this.dateFormat);
      }

    }
    if (value != undefined && value.toString().indexOf('.') != -1 && value.toString().split(".")[1].length > 4)
      return value.toFixed(4);
    else
      return value;
  }

  getTooltipValue(row: any, col: string, value: any) {
    if (col == 'feasibilityStatus' || col == 'costsStatus' || col == 'deliveryStatus') {
      let _val: string = this.getValue(row, col, value);
      if (!_val) return value;
      if (_val.toString().startsWith("<i")) {
        if (col == 'feasibilityStatus' && row["feasibilityInfo"] != '')
          return row["feasibilityInfo"];
        else
          return value;
      } else {
        return _val;
      }
    } else {
      return null;
    }

  }

  cellClick(col: string, row: any) {
    if (col != 'attachments') return;
    if (row["attachments"] == '') return;
    let _temp: ClickedCell = new ClickedCell();
    _temp.colName = col;
    _temp.row = JSON.stringify(row);
    this.onCellClick.emit(_temp);
  }

  /** FILTERS */
  filterDataSet(searchString: any, col: string) {
    this.imFiltering.emit(true);
    if (this.pageDataSet.length == 0) this.setPagination();
    this.pageDataSet = this.pageDataSet.filter(x => x[col].toLowerCase().includes(searchString.toLowerCase()));
    this.setFocusOnBody();
    this.refreshColumnsWidth();

  }

  filterDataSetByDate(date: number, col: string, operator: string) {
    this.imFiltering.emit(true);
    if (this.pageDataSet.length == 0) this.setPagination();
    const filterKey = this.getDateComparisonKey(date);
    if (filterKey == '') return;

    if (operator == 'eq')
      this.pageDataSet = this.pageDataSet.filter(x => this.getDateComparisonKey(x[col]) == filterKey);

    if (operator == 'lt')
      this.pageDataSet = this.pageDataSet.filter(x => {
        const rowKey = this.getDateComparisonKey(x[col]);
        return rowKey != '' && rowKey < filterKey;
      });

    if (operator == 'gt')
      this.pageDataSet = this.pageDataSet.filter(x => {
        const rowKey = this.getDateComparisonKey(x[col]);
        return rowKey != '' && rowKey > filterKey;
      });

    this.setFocusOnBody();
    this.refreshColumnsWidth();
  }

  private getDateComparisonKey(value: any): string {
    return getDateOnlyKey(typeof value === 'number' ? value : Number(value));
  }

  private getDisplayDate(value: number, col: string): Date {
    if (this.isDateOnlyColumn(col)) {
      return getDateOnlyDisplayDate(value) || new Date(value);
    }

    return new Date(value);
  }

  private isDateOnlyColumn(col: string): boolean {
    return this.dateOnlyColumnsSet.has(col.toLowerCase());
  }

  setFocusOnBody() {
    if (this.filterTimerId != undefined) clearTimeout(this.filterTimerId);
    this.filterTimerId = setTimeout(() => {
      this.selectedIndex = 0;
      $('.tg-body-cnt').focus();
      clearTimeout(this.filterTimerId);
    }, 500);
  }

  /**
   * ON CHANGE INPUT FILTER
   * @param evt 
   * @param col 
   * @param colType 
   */
  onInputChangeFilter(evt: any, col: string, colType: string) {
    this.gridFilters.filters!.filter(x => x.dataField?.toLowerCase() == col.toLowerCase())[0].filterValue = evt;
    if (evt == '') {
      this.setPagination();
    } else {
      this.filterDataSet(evt, col);
    }
  }

  /**
   * ON CHANGE DATA
   * @param evt 
   * @param col 
   */
  onChangeDataFilter(evt: string, col: string) {
    this.gridFilters.filters!.filter(x => x.dataField?.toLowerCase() == col.toLowerCase())[0].filterValue = parseInt(evt.split("|")[0]);
    if (parseInt(evt.split("|")[0]) == undefined) return;
    if (evt == '') {
      this.setPagination();
    } else {
      this.filterDataSetByDate(parseInt(evt.split("|")[0]), col, evt.split("|")[1]);
    }
  }

  clearAllFilters() {
    for (var x = 0; x < this.gridFilters.filters!.length; x++) {
      this.gridFilters.filters![x].filterValue = null;
    }
    this.imFiltering.emit(false);
    this.setPagination();
  }

  getUserLogged(row: any): boolean {
    if (this.globals.userLogged!.username! == row["username"]) return true;
    return false;
  }

  getFilterValue(col: string): any {
    return this.gridFilters.filters!.filter(x => x.dataField?.toLowerCase() == col.toLowerCase())[0].filterValue;
  }

  onCalculateColClick(col: string, row: any) {

    if (this.origin == 'edit-enquiry') {
      // questo controllo ha senso solo se origin edit enquiry
      if (this.salesOfficeId != null && !this.utils.isAuthorized("Office", "EditEnquiry", this.salesOfficeId!)) return;
    }
    else {
      this.isModalReadOnly = true; // always read only except while origin is edit enquiry
    }

    // se lo stato non e'valido e l'origine non e' edit enquiry allora return
    // if (row[col] != 'Validated' && this.origin != 'edit-enquiry') return; // commented out as customer request on april 18th 2025

    if (row[col] == "ItdcrInProgress" && (col == "feasibilityStatus" || col == "costsStatus" || col == "deliveryStatus")) return; // if status ItdcrInProgress do nothing

    if (col == 'feasibilityStatus') {

      this.itemNo = row["itemNo"];
      this.feasibilityStatus = row[col];
      this.feasibilitySource = row["feasibilitySource"];
      this.feasibilitySourceDescription = row["feasibilitySourceDescription"];


      // if status is ItdcrToBeConfirmed open ITDCR modal
      if (this.feasibilityStatus == 'ItdcrToBeConfirmed') {
        this.showFeasibilityOptionsItdcrModal = true;
      }
      else {
        this.showFeasibilityOptionsModal = true;
      }

    }

    if (col == "costsStatus") {
      this.itemNo = row["itemNo"];
      this.row = row;
      this.rawMaterialGrade = row["rawMaterialGrade.rawMaterialGradeCode"];
      this.costsSourceCostingToolRecordId = row["costsSourceCostingToolRecordId"] != '' ? parseInt(row["costsSourceCostingToolRecordId"]) : null;
      this.costsSourceCostingToolVersionId = row["costsSourceCostingToolVersionId"] != '' ? parseInt(row["costsSourceCostingToolVersionId"]) : null;
      this.costsSourceDescription = row["costsSourceDescription"];
      // MQF-492 - Ora apre sempre in modalit' ctTool-info
      /* if (row[col] != 'Validated')
        this.modalPriceOpenAs = 'ctTool-Ictdr';
      else
        this.modalPriceOpenAs = 'ctTool-Info'; */

      this.modalPriceOpenAs = 'ctTool-Info';
      this.showModalPriceOptions = true;
    }

    if (col == "deliveryStatus") {
      this.itemNo = row["itemNo"];
      this.row = row;
      this.showDeliveryOptionsModal = true;
    }
  }

  onCalculateColRightClick($event: MouseEvent, col: string, row: any) {
    $event.preventDefault(); // Prevent the default browser context menu
    $event.stopPropagation();

    this.customIconContextMenuClick.emit({ row, col });
    // if (col == 'costsStatus' && row[col] == 'ToBeEvaluated') {
    //   // jump to costing tool page
    //   this.router.navigate(["/costing-tool"], { queryParams: { enquiryNo: this.enquiryNo, itemNo: row['itemNo'], origin: this.origin }, state: { item: row } });

    // }
  }

  customIcoClickable(col: string): boolean {
    if (col == 'feasibilityStatus') {
      if (this.salesOfficeId != null && !this.utils.isAuthorized("Office", "EditEnquiry", this.salesOfficeId!)) return false;
    }
    return true;
  }

  onCloseFeasibility(evt: any[]) {
    if (evt && evt.length > 0) {
      this.pageDataSet = new Array();
      this.pageDataSet = evt;
    }
    this.showFeasibilityOptionsModal = false;
    this.showFeasibilityOptionsItdcrModal = false;
  }

  /* MODAL PRICE OPTIONS */
  onCloseModalPriceOptions(evt: any) {
    this.showModalPriceOptions = false;
    if (evt == 'refresh') this.reloadMyDataset.emit(true);
  }

  onOpenCostingToolModal(evt?: {
    useNearestMatch?: boolean;
    origin?: string;
    costsSourceCostingToolRecordId?: number | null;
    costsSourceCostingToolVersionId?: number | null;
  }) {
    if (!this.row || !this.enquiryNo) return;
    this.showModalPriceOptions = false;
    this.costingToolItem = this.row;
    this.costingToolOrigin = evt?.origin || this.origin;
    this.costingToolUseNearestMatch = evt?.useNearestMatch === true;
    this.costingToolRecordId = evt?.costsSourceCostingToolRecordId ?? null;
    this.costingToolVersionId = evt?.costsSourceCostingToolVersionId ?? null;
    this.costingToolUnitSystem = this.enquiryHeader?.unitSystem || (this.enquiryHeader as any)['UnitSystem'];
    this.costingToolCurrency = this.enquiryHeader?.currency || (this.enquiryHeader as any)['Currency'];
    this.showCostingToolModal = true;
  }

  onCloseCostingToolModal() {
    this.showCostingToolModal = false;
    this.costingToolItem = null;
    this.costingToolOrigin = '';
    this.costingToolUseNearestMatch = false;
    this.costingToolRecordId = null;
    this.costingToolVersionId = null;
    this.costingToolUnitSystem = null;
    this.costingToolCurrency = null;
    this.reloadMyDataset.emit(true);
  }

  onCloseModalDeliveryOptions(evt: any) {
    this.showDeliveryOptionsModal = false;
    this.reloadMyDataset.emit(true);
  }

  onOpenItdcrClick($event: OpenItdcrEvent) {
    this.showDeliveryOptionsModal = false;
    this.onOpenITDCR.emit($event);
  }


  /* EDITABLE SECTION */
  onInputEditable(evt: any, row: any, i: number, col: string) {
    let _val: any = evt["currentTarget"]["value"];

    // Replace comma with dot
    const normalizedInput = _val.replace(',', '.');

    // Parse the number
    const parsedNumber = parseFloat(normalizedInput);

    // Check if the result is a valid number
    if (isNaN(parsedNumber)) {
      //this.dataSet[i][col] = null;
      return;
    }

    this.pageDataSet[i][col] = parsedNumber;
    if (JSON.stringify(this.pageDataSet) != JSON.stringify(this.oldPageDataSet))
      this.onHotChange.emit(true);
    else
      this.onHotChange.emit(false);
  }

  /**
 * GRID SETTINGS EVENTS
 * @param evt 
 */
  showSettings() {
    this.showSettingsDialog = true;
  }

  onCloseSettings(evt: any) {
    this.showSettingsDialog = false;
  }

  onApplySettings(gridConfiguration: GridConfiguration) {
    // this.teiasoftLoader.start();
    this.gridConfiguration = new GridConfiguration()
    this.gridConfiguration = gridConfiguration;
    this.applyGridConfiguration(this.gridConfiguration);
    this.onUpdateConfiguration(this.gridConfiguration);
    this.refreshColumnsWidth();
    this.recomputeStickyAndLeft();
    this.showSettingsDialog = false;
  }

  onUpdateConfiguration(gridConfiguration: GridConfiguration) {
    this.utils.upsertGridConfiguration(gridConfiguration);
    this.updateUserConfiguration();
  }

  updateUserConfiguration() {
    this.backendService.updateUserConfiguration(this.globals.userLogged!.configuration!, this.globals.userLogged!.language!, this.globals.userLogged!.dateFormat!).subscribe(() => {
      localStorage.setItem("userLogged", JSON.stringify(this.globals.userLogged!));
    });
  }

  hasCustomHeaderRenderer(col: string): boolean {
    return !!this.customHeaderRenderers[col];
  }

  getCustomHeaderRenderer(col: string): { template: TemplateRef<any>, context: any } | null {
    return this.customHeaderRenderers[col] ? this.customHeaderRenderers[col]() : null;
  }

  hasCustomRenderer(col: string): boolean {
    return !!this.customRenderers[col];
  }

  getCustomRenderer(col: string, row: any): { template: TemplateRef<any>, context: any } | null {
    return this.customRenderers[col] ? this.customRenderers[col](row) : null;
  }

  isSticky(index: number): boolean {
    return index < this.gridConfiguration.activeFrozenColumns;
  }

  getStickyLeftPosition(index: number): number | undefined {
    let visibleFrozenColumns = this.gridConfiguration!.gridColumns!
      .filter(gc => gc.visible && gc.position! <= this.gridConfiguration.frozenColumns);

    let frozenIdx = visibleFrozenColumns.findIndex(vfc => vfc.name == this.gridColumns![index])
    const isFrozen = frozenIdx != -1;

    if (!isFrozen)
      return undefined;

    // OK



    let leftPosition = this.stickyContainerWidth; // Start with initial offset

    // Sum up all previous *visible frozen* columns' widths
    for (let i = 0; i < frozenIdx; i++) {
      leftPosition += visibleFrozenColumns[i]?.width ?? 0;
    }

    return leftPosition;

    // let visibleFrozenColumnWidth = this.stickyContainerWidth;
    // visibleFrozenColumns.forEach( (c,idx) => {
    //   if(idx < index)
    //   visibleFrozenColumnWidth += c.width!
    // } );

    // return index < this.gridConfiguration.frozenColumns ? visibleFrozenColumnWidth : undefined;

    // let visibleIndex = visibleFrozenColumns.findIndex(col => col.position === index);

    // if (visibleIndex !== -1) {
    //   return visibleFrozenColumnWidth;
    // }

    return undefined;
    // Find the column by position
    // let column = this.gridConfiguration!.gridColumns![index];
    // if (!column) return undefined; 

    // let visibleIndex = visibleFrozenColumns.findIndex(col => col.position === column.position);

    // if (visibleIndex !== -1) {
    //   let leftPosition = this.stickyContainerWidth; // Start with initial offset

    //   // Sum up all previous *visible frozen* columns' widths
    //   for (let i = 0; i < visibleIndex; i++) {
    //     leftPosition += visibleFrozenColumns[i]?.width ?? 0;
    //   }

    //   return leftPosition;
    // }

    // return undefined;
  }

  onSubmitItdcrFeasibility($event: 'Confirm' | 'Reject') {
    this.backendService.submitItdcrFeasibilityDecision(this.enquiryNo!, this.itemNo!, $event).subscribe(() => {
      this.showFeasibilityOptionsItdcrModal = false;
      this.teiasoftToaster.show("success", this.translateService.instant("commons.success"));
      this.reloadMyDataset.emit(true);
    });
  }

}
